import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import * as api from "../../../api/index";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import SourcesList from "./SourcesList";
import AddEditSource from "./AddEditSource";
import { getSources } from "actions/sources.action";

const Sources = (props) => {
  const [addnewform, setaddnewform] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const dispatch = useDispatch();

  const closeForm = () => {
    setaddnewform(false);
  };

  React.useEffect(() => {
    if (props.onClose === false) {
      closeForm();
    }
  }, [props.onClose]);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const postingData = {
        data: {
          ...data,
          active: data.active ?? true,
          sourceType: "Matter",
        },
      };
      await api.addSource(postingData);
      toast.success("Source Added Successfully");
      dispatch(getSources());
      setaddnewform(false);
    } catch (error) {
      toast.error("Error Occurred While Adding Source");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-lg-10 col-md-8"></div>
        <Button
          className={`common-btn col-lg-1 col-md-4 p-2 mt-5 ${styles.button}`}
          onClick={() => setaddnewform(true)}
        >
          Add <br />
          Source
        </Button>
      </div>
      <div className="row mx-auto mt-3 col-12 col-xl-9 col-xxl-6">
        <SourcesList />
      </div>

      {addnewform && (
        <AddEditSource
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </React.Fragment>
  );
};

export default Sources;
